"use client"

import React from "react"
import { SIGN_UP_URI } from "config/route-path"

import { Box, Button } from "@bullseye/components"

const SignUpButton = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box className="inline">
      <Button as="a" href={SIGN_UP_URI}>
        {children}
      </Button>
    </Box>
  )
}

export default SignUpButton
